import ISchedule, {
    defaultClosingSchedule,
    defaultOpeningSchedule,
} from "../../Schedule";
import IAdminPageBuildingDetail from "../../adminPage/adminPageBuildingDetail";
import ICleaningSchedule from "../../cleaningSchedule";

const DEFAULT_MIN_CLEANING = 10;

export default interface ILocalEditRequest {
    id: number;
    buildingId: number;
    propertyGroupId?: number;
    managerId?: number;
    floorId: number;
    name: string;
    capacity?: number;
    isAccessCodeRequired?: boolean;
    profileId: number;
    localTenantIds?: number[];
    openingSchedule?: ISchedule;
    closingSchedule?: ISchedule;
    codes: string[];
    gxSecurityCode?: string;
    tagMacAddress?: string;
    alarmCode?: string;
    profileTasksIds?: number[];
    localCleaning: ICleaningSchedule;
    specification?: string;
    isLocked?: boolean;
    buildings?: IAdminPageBuildingDetail[];
    servicePlusStickerCode?: string;
}

export const defaultLocalRequest: ILocalEditRequest = {
    id: 0,
    buildingId: 0,
    managerId: 0,
    floorId: 0,
    name: "",
    capacity: 0,
    isAccessCodeRequired: false,
    profileId: 0,
    localTenantIds: [],
    codes: [],
    gxSecurityCode: "",
    alarmCode: "",
    profileTasksIds: [],
    openingSchedule: defaultOpeningSchedule,
    closingSchedule: defaultClosingSchedule,
    localCleaning: {
        id: 0,
        friday: DEFAULT_MIN_CLEANING,
        localId: 0,
        monday: DEFAULT_MIN_CLEANING,
        saturday: DEFAULT_MIN_CLEANING,
        sunday: DEFAULT_MIN_CLEANING,
        thursday: DEFAULT_MIN_CLEANING,
        tuesday: DEFAULT_MIN_CLEANING,
        wednesday: DEFAULT_MIN_CLEANING,
    },
    specification: "",
    isLocked: false,
};
